import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import AdminUserTypes from './constants'

import * as adminUserActions from './actions'

const getAdminUserListState = state => state.adminUserList;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function loadUsersApi (formData) {
  const request = axiosApi().post(
    AdminUserTypes.LOAD_USERS_API, 
    formData
  )

  return handleRequest(request);
}
function loadLuongCoBanApi (formData) {
  const request = axiosApi().post(
    AdminUserTypes.LOAD_LUONG_CO_BAN_API, 
    formData
  )

  return handleRequest(request);
}
function listRequestApi (formData) {
  const request = axiosApi().post(
    AdminUserTypes.LIST_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemRequestApi (formData) {
  const request = axiosApi().post(
    AdminUserTypes.ITEM_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemAddRequestApi (formData) {
  const request = axiosApi().post(
    AdminUserTypes.ITEM_ADD_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemUpdateRequestApi (formData) {
  const request = axiosApi().post(
    AdminUserTypes.ITEM_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemRemoveRequestApi (formData) {
  const request = axiosApi().post(
    AdminUserTypes.ITEM_REMOVE_API, 
    formData
  )

  return handleRequest(request);
}

function* loadUsers ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(loadUsersApi, payload)
    // dispatch the action with our widgets!
    yield put(adminUserActions.setUsers(results.data))
  } catch (error) {
    yield put(adminUserActions.adminUserListError(error))
  }
}
function* loadLuongCoBan ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(loadLuongCoBanApi, payload)
    // dispatch the action with our widgets!
    yield put(adminUserActions.setLuongCoBan(results.data.records))
  } catch (error) {
    yield put(adminUserActions.adminUserListError(error))
  }
}

function* adminUserListRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(adminUserActions.adminUserListSuccess(results.data))
  } catch (error) {
    yield put(adminUserActions.adminUserListError(error))
  }
}

function* adminUserItemRequestFlow () {
  const adminUserList = yield select(getAdminUserListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemRequestApi, adminUserList.formData);
    // dispatch the action with our widgets!
    yield put(adminUserActions.adminUserItemSuccess(results.data));
  } catch (error) {
    yield put(adminUserActions.adminUserItemError(error));
  }
}

function* adminUserItemAddRequestFlow (action) {
  const adminUserList = yield select(getAdminUserListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemAddRequestApi, adminUserList.formData)
    if (results.code != 200) {
      yield put(adminUserActions.adminUserItemAddError(results.message));
    }
    else {
      // dispatch the action with our widgets!
      yield put(adminUserActions.adminUserItemAddSuccess(results));
    }
  } catch (error) {
    yield put(adminUserActions.adminUserItemAddError(error))
  }
}

function* adminUserItemUpdateRequestFlow () {
  const adminUserList = yield select(getAdminUserListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemUpdateRequestApi, adminUserList.formData)

    if (results.code != 200) {
      yield put(adminUserActions.adminUserItemUpdateError(results.message));
    }
    else {
      // dispatch the action with our widgets!
      yield put(adminUserActions.adminUserItemUpdateSuccess(results));
    }

  } catch (error) {
    yield put(adminUserActions.adminUserItemUpdateError(error))
  }
}

function* adminUserItemRemoveRequestFlow () {
  const adminUserList = yield select(getAdminUserListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemRemoveRequestApi, adminUserList.formData)

    if (results.code != 200) {
      yield put(adminUserActions.adminUserItemRemoveError(results.message));
    }
    else {
      // dispatch the action with our widgets!
      yield put(adminUserActions.adminUserItemRemoveSuccess(results.message));
    }

  } catch (error) {
    yield put(adminUserActions.adminUserItemRemoveError(error));
  }
}

function* adminUserWatcher () {
  yield [
    takeLatest(AdminUserTypes.LOAD_USERS, loadUsers),
    takeLatest(AdminUserTypes.LOAD_LUONG_CO_BAN, loadLuongCoBan),
    takeLatest(AdminUserTypes.LIST_REQUESTING, adminUserListRequestFlow),
    takeLatest(AdminUserTypes.ITEM_REQUESTING, adminUserItemRequestFlow),
    takeLatest(AdminUserTypes.ITEM_ADD_REQUESTING, adminUserItemAddRequestFlow),
    takeLatest(AdminUserTypes.ITEM_UPDATE_REQUESTING, adminUserItemUpdateRequestFlow),
    takeLatest(AdminUserTypes.ITEM_REMOVE_REQUESTING, adminUserItemRemoveRequestFlow),
  ]
}

export default adminUserWatcher



// WEBPACK FOOTER //
// ./src/views/Admin/AdminUser/sagas.js